<template>
    <el-dialog
      :title="$t('org.confirmOperation')"
      :visible.sync="visible"
      width="30%"
    >
      <span>{{ $t('org.confirmDeleteRelStaff') }}</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="visible = false">{{ $t('org.cancelDelete') }}</el-button>
        <el-button type="primary" @click="handleConfirm">{{ $t('org.confirm') }}</el-button>
      </span>
    </el-dialog>
  </template>
  
  <script>
  import { deleteOrgRelStaff } from '@/api/org/orgApi'
  
  export default {
    name: 'DeleteOrgRelStaff',
    data() {
      return {
        visible: false,
        currentStaff: null
      }
    },
    methods: {
      open(staff) {
        this.currentStaff = staff
        this.visible = true
      },
      show(staff) {
        this.currentStaff = staff
        this.visible = true
      },
      handleConfirm() {
        deleteOrgRelStaff({
          staffId: this.currentStaff.userId,
          orgId: this.currentStaff.orgId
        }).then(response => {
            console.log(response)
          if (response.code === 0) {
            this.$message.success(this.$t('org.deleteSuccess'))
            this.visible = false
          } else {
            this.$message.error(response.msg)
          }

          this.$emit('refresh')
        })
      }
    }
  }
  </script>